<template>
  <div class="notice">
    <van-tabs animated color="#1678ff">
      <van-tab title="更新日志">
        <div class="item" v-for="(item, index) in list" :key="index" @click="details(item.id)" >
          <div class="title"> {{ item.version }} 主要更新</div>
          <div class="time" @click="details(item.id)">{{ item.date }} </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import {queryReleaseNotesList} from "@/api/releaseNotes"
export default {
  name: 'releaseNotes',
  components: { },
  data() {
    return {
      list: [],
      loading: false,
      error: false,
      pageIndex: 0,
      pageSize: 500,
      totalPage: 0,
      total: 0,
      showEmpty:false,
    }
  },
  computed: {},
  created() {
    this.getList();
  },
  methods: {
    getList() {
      this.loading = true;
      queryReleaseNotesList(this.pageIndex,this.pageSize)
          .then((res) => {
            this.list = res.data;
            this.total = res.total;
            this.totalPage = res.totalPage;
            this.pageIndex = res.pageIndex;
            this.loading = false;
          })
          .catch((e) => {
            this.loading = false;
          });
    },
    details(id){
      this.$router.push("/releaseNotes/detail/"+id)
    }
  }
}
</script>
<style scoped lang="scss">
  @import "../../assets/css/theme/theme";
  .notice {
    .van-tab__pane-wrapper {
      padding: 5px 15px 0;
      margin-top: 5px;
      background: #fff;
    }

    .item {
      position: relative;
      height: 45px;
      border-bottom: 0.02667rem solid #e5e5e5;
      padding: 8px 0px 0px 5px;

      &:after {
        position: absolute;
        top: 50%;
        right: 15px;
        transform: rotate(45deg) translateY(-50%);
        content: " ";
        display: inline-block;
        height: 6px;
        width: 6px;
        border-width: 2px 2px 0 0;
        border-color: #C8C8CD;
        border-style: solid;
      }
    }
    .title {
      position: relative;
      font-size: 14px;
    }
    .time {
      position: relative;
      font-size: 12px;
      color: gray;
      padding: 10px 0px 0px 0px;
    }
  }
</style>
